var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.cssClass,on:{"click":function($event){$event.preventDefault();return _vm.downloadFile(_vm.url)}}},[_vm._v(_vm._s(_vm.title)+" "),(_vm.icon)?_c('i',{staticClass:"icon-download"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }